import { useEffect, useState } from "react";
import { ActionType, useProductReducer } from "../Products/lib/reducer";
import { getCollectionFromRedis } from "@lib/redis";
import { trackEvent } from "@lib/track-event";
import { OFFSET } from "../Products/lib/constants";
import { detectRobot } from "@lib/detectRobot";

const fetchFromDB = async (dispatch, collectionHandle) => {
  const productsFromCollection = await getCollectionFromRedis(collectionHandle, 10, OFFSET);
  // fetch data from our database
  dispatch({
    type: ActionType.FETCH_FROM_DB,
    products: productsFromCollection,
  });
};

const impressionItemList = (state) => {
  const start = (state.page - 1) * OFFSET;
  const end = state.page * OFFSET;
  const items = state.products.slice(start, end);
  return {
    offset: start,
    filteredProducts: items,
  };
};

export const useProductsFromCollection = (collection, initialProducts) => {
  const [state, dispatch] = useProductReducer({
    products: initialProducts,
    isFetching: false,
    page: 1,
    error: {},
  });

  const [isRobot, setIsRobot] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent;
    const result = detectRobot(userAgent);
    setIsRobot(result);
  }, []);

  useEffect(() => {
    if (collection) {
      fetchFromDB(dispatch, collection.handle);
    }
    // const allProducts = [];
    // ( async() => {
    //   if (collection) {
    //     let keepFetching = true;
    //     let page = 2;
    //     while (keepFetching) {
    //       const data = await getCollectionFromRedis(collection.handle, page, 75);
    //       page++;

    //       if (page <=2 ) {
    //         dispatch({
    //           type: ActionType.ADD_PRODUCTS,
    //           products: data.products,
    //         });
    //       } else {
    //         allProducts.push(...data.products);
    //       }
    //       if (data.end >= data.total) {
    //         keepFetching = false;
    //       }
    //     }
    //     dispatch({
    //       type: ActionType.ADD_PRODUCTS,
    //       products: allProducts,
    //     });
    //   }
    // })()//
  }, [collection]);

  useEffect(() => {
    if (isRobot && state.products?.length > 0) {
      dispatch({
        type: ActionType.FETCH_ALL,
      });
    }
  }, [isRobot, state.products]);

  useEffect(() => {
    if (state.products?.length && state.page > 0) {
      trackEvent("view_item_list", {
        ...impressionItemList(state),
        collection,
      });
    }
  }, [state.page]);

  return {
    productsFromCollection: state.products,
    state,
    dispatch,
  };
};
